import {withStyles} from "@mui/styles";
import {lightBlue} from "@mui/material/colors";
import StepConnector from "@mui/material/StepConnector";

const NautilusConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-100% + 50%)',
        right: 'calc(0% + 50%)'
    },
    active: {
        '& $line': {
            backgroundColor: lightBlue[500],
        },
    },
    completed: {
        '& $line': {
            backgroundColor: lightBlue[500],
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

export default NautilusConnector;